import {
  GROUP_TYPE,
  IGroupInfo,
  IRecentContacts,
} from "@home-health-notify/domain";
import { getAvatarSize, GROUP_AVATAR_SIZE } from "../../../utils/AvatarUtils";
import { CommonChatHeaderDescription } from "../../messageHeader/CommonChatHeaderDescription";
import { PatientHeaderDescription } from "../../messageHeader/patientGroupHeader/PatientHeaderDescription";
import {
  MessageItemModalListItem,
  MessageItemModalListItemContent,
  MessageItemModalListItemStyle,
  StyledCheckbox,
} from "../MessagePanel.style";

interface ForwardToListItemProps {
  contact: IRecentContacts;
  selectedContactsToForwardTo: IRecentContacts[];
  handleContactSelected: (selectedContact: IRecentContacts) => void;
}

function ForwardToListItem({
  contact,
  selectedContactsToForwardTo,
  handleContactSelected,
}: ForwardToListItemProps) {
  const isPrivateChat = contact.groupType === GROUP_TYPE.PRIVATE;
  const isPatientGroup = contact.groupType === GROUP_TYPE.PATIENT;
  const isInternalGroup = contact.groupType === GROUP_TYPE.NON_PATIENT;
  const isChecked = selectedContactsToForwardTo.some(
    item => item.id === contact.id,
  );
  const groupContact =
    isPatientGroup || isInternalGroup ? (contact as IGroupInfo) : undefined;
  return (
    <MessageItemModalListItem
      key={contact.id}
      showCheckbox={true}
      divider
      disableGutters
      secondaryAction={
        <StyledCheckbox
          edge="end"
          checked={isChecked}
          onChange={() => handleContactSelected(contact)}
        />
      }
    >
      <MessageItemModalListItemStyle
        disableRipple
        disableTouchRipple
        showCheckbox={true}
        onClick={() => handleContactSelected(contact)}
      >
        <MessageItemModalListItemContent>
          {isPatientGroup && groupContact && (
            <PatientHeaderDescription
              name={contact.name}
              mrn={groupContact.mrn}
              patientStatus={groupContact.patientStatus}
              servicesToPatient={groupContact.servicesToPatient}
              meta={groupContact.meta}
              avatarSize={GROUP_AVATAR_SIZE.SMALL}
              fontSizeTitle={20}
            />
          )}
          {(isPrivateChat || isInternalGroup) && (
            <CommonChatHeaderDescription
              chatInfo={contact}
              avatarSize={getAvatarSize(
                contact.groupType,
                GROUP_AVATAR_SIZE.SMALL,
              )}
              fontSizeTitle={20}
              showUserAbout={false}
              showUserStatus={false}
            />
          )}
        </MessageItemModalListItemContent>
      </MessageItemModalListItemStyle>
    </MessageItemModalListItem>
  );
}

export default ForwardToListItem;
